import { Alert, Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import React from 'react';
import {
  isLikelyTooSmallInsidePostMeasurement,
  LIKELY_TOO_SMALL_INSIDE_POST_MESSAGE,
  normalizeTrussSizeInches,
  ProductType,
  resolveEffectiveSizeFeet,
  resolveInsidePostMeasurementForTruss,
} from '../truss-calculation';
import { formatMeasurement } from '../truss-utils';

interface InsidePostMeasurementFieldProps {
  sizeFeet: number;
  sizeFeetInput?: string;
  sizeInches: number | null | undefined;
  productType: ProductType;
  postSize: string;
  monoslopeTruss?: boolean;
  postSizeOverride?: boolean | null;
  postSizeOverrideValue?: string | null;
  confirmedMeasurementInsidePost: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
}

const InsidePostMeasurementField: React.FC<InsidePostMeasurementFieldProps> = ({
  sizeFeet,
  sizeFeetInput,
  sizeInches,
  productType,
  postSize,
  monoslopeTruss,
  postSizeOverride,
  postSizeOverrideValue,
  confirmedMeasurementInsidePost,
  onConfirmedChange,
}) => {
  const effectiveSizeFeet = resolveEffectiveSizeFeet(sizeFeet, sizeFeetInput);
  const measurementInsidePost = resolveInsidePostMeasurementForTruss(
    effectiveSizeFeet,
    normalizeTrussSizeInches(sizeInches),
    productType,
    postSize,
    {
      monoslopeTruss,
      postSizeOverride,
      postSizeOverrideValue,
    }
  );
  const measurementText = formatMeasurement(measurementInsidePost);

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        Measurement inside post to inside post: {measurementText}
      </Typography>
      {isLikelyTooSmallInsidePostMeasurement(measurementInsidePost) && (
        <Alert severity="warning" sx={{ mb: 1 }}>
          {LIKELY_TOO_SMALL_INSIDE_POST_MESSAGE}
        </Alert>
      )}
      <FormControlLabel
        control={
          <Checkbox
            checked={confirmedMeasurementInsidePost}
            onChange={e => onConfirmedChange(e.target.checked)}
            required
          />
        }
        label="Please confirm inside post to post measurement"
        required
      />
    </Box>
  );
};

export default InsidePostMeasurementField;
